module.exports = __webpack_public_path__ + "img/demo.bc2a40b7.jpg";